declare const um_domain: string;
declare const casino_iframe: string;
declare const CMS_API: string;
export const API_URL = `${um_domain}`;

export const IFRAME_URL = `${casino_iframe}/Casino/lobby/loader`;
export const GamesEndpointUrl = `${API_URL}/games`;
export const GameWeekEndpointUrl = `${API_URL}/gow`;
export const UserFavoritesEndpointUrl = `${API_URL}/favorites`;

export const CategoriesEndpointUrl = `${API_URL}/categories`;
export const ProvidersEndpointUrl = `${API_URL}/providers`;
export const BannersEndpointUrl = `${CMS_API}/banner`;

export const perPage = 18;

export const CATEGORYTYPE_CASINO = 1;
export const CATEGORYTYPE_LIVECASINO = 2;
